import { ErrorText } from "Components/Shared/Errors/ErrorText";
import type { PaymentErrorCode } from "Infrastructure/Api/Api";
import { useResource } from "Translations/Resources";
import { getPaymentFailureMessageKey } from "Utils/PaymentErrorUtils";

type Props = {
  failureReason: PaymentErrorCode;
};

/**
 * Why the bank payment failed, in the user's words. Callers render it only for a failed/cancelled transaction;
 * `None` (nothing failed yet) still renders nothing so the component guards itself.
 */
export const PaymentFailureMessage = ({ failureReason }: Props) => {
  const { t } = useResource();
  const messageKey = getPaymentFailureMessageKey(failureReason);

  if (!messageKey) {
    return null;
  }

  return (
    <ErrorText textAlign="center" role="status" aria-live="polite">
      {t(messageKey)}
    </ErrorText>
  );
};
